import { AccountDatasource } from './../../../../lib/user_app/datasources/account_datasource';
import { ILog } from './../../types';
import { ICommand } from 'core-ts-types';
import { MemberDatasource, IMemberDatasource } from '../../datasources/member_datasource';

export class ApplicationHeaderController {
  public models: {
    memberDatasource: IMemberDatasource;
    accountDatasource: AccountDatasource;
  };

  constructor(
    private $state: ng.ui.IStateService,
    private logoutCommand: ICommand,
    private logoutNotificationCommand: ICommand,
    private log: ILog,
    ngMemberDatasource: MemberDatasource,
    ngAccountDatasource: AccountDatasource
  ) {
    this.models = {
      memberDatasource: ngMemberDatasource.read(),
      accountDatasource: ngAccountDatasource
    };
  }

  isUrl(part: string): boolean {
    return this.$state.includes(part);
  }

  logout(): void {
    this.logoutNotificationCommand();
  }
}

angular
  .module('capability-ng-global')
  .controller('ngApplicationHeaderController', ApplicationHeaderController)
  .directive('applicationHeader', function(): ng.IDirective {
    return {
      restrict: 'E',
      templateUrl: 'lib/global/components/application_header/application_header.html',
      controller: 'ngApplicationHeaderController',
      controllerAs: '$ctrl',
      scope: {}
    };
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/application_header/application_header.ts